import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypeBackground {
    card?: string;
  }
  interface Palette {
    statusChip?: {
      success: string;
      failed: string;
      running: string;
      pending: string;
      warning: string;
      skipped: string;
      noStatus: string;
    };
    metricTable?: {
      baseline?: {
        header: string;
        cell: string;
      };
      bestInClass?: {
        header: string;
        cell: string;
      };
      lastMonth?: {
        header: string;
        cell: string;
      };
    };
  }
  interface PaletteOptions {
    statusChip?: {
      success: string;
      failed: string;
      running: string;
      pending: string;
      warning: string;
      skipped: string;
      noStatus: string;
    };
    metricTable?: {
      baseline?: {
        header: string;
        cell: string;
      };
      bestInClass?: {
        header: string;
        cell: string;
      };
      lastMonth?: {
        header: string;
        cell: string;
      };
    };
  }
}

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      // main: '#ff6600',
      main: '#0f284c',
    },
    secondary: {
      // main: '#0f284c',
      main: '#ff6600',
    },
    background: {
      paper: 'white',
      card: '#f8f9fa',
    },
    grey: {
      50: '#f8f9fa',
      100: '#e9ecef',
      200: '#dee2e6',
      300: '#ced4da',
      400: '#adb5bd',
      500: '#6c757d',
      600: '#495057',
      700: '#343a40',
      800: '#212529',
      900: '#121416',
    },
    statusChip: {
      success: '#1B5E20',
      failed: '#D32F2F',
      running: '#43A047',
      pending: '#5E35B1',
      warning: '#ED6C02',
      skipped: '#EC407A',
      noStatus: '#BDBDBD',
    },
    metricTable: {
      baseline: {
        header: '#E3F2FD', // Light blue for header
        cell: '#F0F8FF', // Very light blue for cells
      },
      bestInClass: {
        header: '#E8F5E9', // Light green for header
        cell: '#F0F9F0', // Very light green for cells
      },
      lastMonth: {
        header: '#FFF9C4', // Light yellow for header
        cell: '#FFFEF5', // Very light yellow for cells
      },
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0F284C',
          color: 'white',
        },
      },
    },
    // MuiButton: {
    //   styleOverrides: {
    //     outlined: {
    //       borderColor: '#0D2748',
    //       borderRadius: '5px',
    //       '&:hover': {
    //         backgroundColor: '#D9D9D9',
    //         color: 'white',
    //       },
    //     },
    //     root: {
    //       '&.Mui-selected': {
    //         backgroundColor: '#0D2748',
    //         color: 'white',
    //       },
    //     },
    //   },
    // },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#0f284c',
    },
    secondary: {
      main: '#ff6600',
    },
    background: {
      paper: '#1a1a1a',
      card: '#2d2d2d',
    },
    grey: {
      50: '#f8f9fa',
      100: '#e9ecef',
      200: '#dee2e6',
      300: '#ced4da',
      400: '#adb5bd',
      500: '#6c757d',
      600: '#495057',
      700: '#343a40',
      800: '#212529',
      900: '#121416',
    },
    statusChip: {
      success: '#1B5E20',
      failed: '#D32F2F',
      running: '#43A047',
      pending: '#5E35B1',
      warning: '#ED6C02',
      skipped: '#EC407A',
      noStatus: '#616161',
    },
    metricTable: {
      baseline: {
        header: '#B3D9FF', // Darker blue for dark mode header
        cell: '#1A3A5C', // Dark blue for dark mode cells
      },
      bestInClass: {
        header: '#B8E6B8', // Darker green for dark mode header
        cell: '#1A3A1A', // Dark green for dark mode cells
      },
      lastMonth: {
        header: '#FFE699', // Darker yellow for dark mode header
        cell: '#3A3A1A', // Dark yellow/cream for dark mode cells
      },
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0F284C',
          color: 'white',
        },
      },
    },
  },
});

// Default export for backward compatibility
export const theme = lightTheme;

// MUI typography font size
// h1: 6.0rem (~96px)
// h2: 3.75rem (~60px)
// h3: 3.0rem (~48px)
// h4: 2.125rem (~34px)
// h5: 1.5rem (~24px)
// h6: 1.25rem (~20px)
// subtitle1: 1.0rem (~16px)
// subtitle2: 0.875rem (~14px)
// body1: 1.0rem (~16px)
// body2: 0.875rem (~14px)
// caption: 0.75rem (~12px)
// overline: 0.75rem (~12px)
